import { MenuItem } from 'components/menu/Menu';

import OutpatientIcon from 'assets/images/benefits/outpatient-icon.svg';
import HospitalisationSurgicalIcon from 'assets/images/benefits/hospitalisation-surgical-icon.svg';
import SupplementaryMajorMedicalIcon from 'assets/images/benefits/supplementary-major-medical-icon.svg';
import DentalIcon from 'assets/images/benefits/dental-icon.svg';
import MaternityIcon from 'assets/images/benefits/maternity-icon.svg';
import WorldwideEmergencyAssistanceIcon from 'assets/images/benefits/worldwide-emergency-assistance-icon.svg';

import { BENEFIT_SECTION_ID } from 'pages/benefits/constants/variables';

export const MENU_ITEMS: MenuItem[] = [
  {
    id: BENEFIT_SECTION_ID.OUTPATIENT,
    label: 'benefits.outpatient',
    icon: OutpatientIcon,
  },
  {
    id: BENEFIT_SECTION_ID.HOSPITALISATION_SURGICAL,
    label: 'benefits.hospitalization',
    icon: HospitalisationSurgicalIcon,
  },
  {
    id: BENEFIT_SECTION_ID.SUPPLEMENTARY_MAJOR_MEDICAL,
    label: 'benefits.supplementaryMajorMedical',
    icon: SupplementaryMajorMedicalIcon,
  },
  {
    id: BENEFIT_SECTION_ID.DENTAL,
    label: 'benefits.dental',
    icon: DentalIcon,
  },
  {
    id: BENEFIT_SECTION_ID.MATERNITY,
    label: 'benefits.maternity',
    icon: MaternityIcon,
  },
  {
    id: BENEFIT_SECTION_ID.WORLDWIDE_EMERGENCY_ASSISTANCE,
    label: 'benefits.emergencyAssistanceMenu',
    icon: WorldwideEmergencyAssistanceIcon,
  },
];
